import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { GraduationCap, Baby, MessageCircle, Coffee, School, Briefcase } from "lucide-react";

const jobs = [
  { icon: GraduationCap, title: "English tutor", copy: "Teach conversational English to children, teenagers, or adults. Flexible hours, strong hourly rates in Paris and Lyon." },
  { icon: Baby, title: "Babysitting & childcare", copy: "French and international families actively seek native English-speaking sitters and part-time nannies." },
  { icon: MessageCircle, title: "Conversation partner", copy: "Help professionals and university students improve their spoken English in one-on-one sessions." },
  { icon: Coffee, title: "Hospitality & tourism", copy: "Restaurants, cafés, hotels, and tourism businesses regularly hire international students in-season." },
  { icon: School, title: "Campus employment", copy: "On-campus jobs through university libraries, admin offices, or student residence services." },
  { icon: Briefcase, title: "Career preparation", copy: "We guide you through a French-style CV, interview prep, and understanding the local job market." },
];

export default function WorkWhileStudy() {
  return (
    <section className="bg-[#0d1b3e] text-white py-24 md:py-32" data-testid="work-while-study">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="rule-gold" /><span className="eyebrow !text-[#b8892b]">Work while you study</span>
        </div>
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <h2 className="md:col-span-8 serif text-5xl md:text-6xl leading-[0.98] tracking-tight">
            Study, work, and <em className="italic text-[#b8892b]">build your future</em> in France.
          </h2>
          <p className="md:col-span-4 text-white/70 text-lg leading-relaxed">
            Your student visa allows part-time work up to 964 hours per year. FrancePath helps you find opportunities where being an American is a competitive advantage.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {jobs.map(({ icon: Icon, title, copy }, i) => (
            <motion.article
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-white/[0.03] border border-white/10 p-6 md:p-8 hover:bg-white/[0.06] transition-colors"
              data-testid={`work-card-${i}`}
            >
              <div className="w-10 h-10 bg-[#b8892b] text-[#0d1b3e] flex items-center justify-center mb-5">
                <Icon size={18} />
              </div>
              <h3 className="serif text-2xl leading-tight">{title}</h3>
              <p className="text-sm text-white/70 mt-3 leading-relaxed">{copy}</p>
            </motion.article>
          ))}
        </div>

        <p className="mt-10 text-xs text-white/50 italic max-w-3xl leading-relaxed">
          Employment opportunities depend on your visa conditions and current French regulations. We share the framework, you make the choices, and if anything binding comes up we point you to your consulate or a licensed advisor.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/advisor" className="btn-sharp btn-sharp-gold" data-testid="work-cta">Start Your Free Plan</Link>
          <a href="https://wa.me/33618797689" target="_blank" rel="noreferrer" className="btn-sharp !bg-transparent !text-white !border-white/40 hover:!bg-white hover:!text-[#0d1b3e]" data-testid="work-cta-whatsapp">
            Ask about jobs
          </a>
        </div>
      </div>
    </section>
  );
}
